import(/* webpackMode: "eager" */ "/home/runner/work/the-platform/the-platform/frontend/events-website/app/not-found.tsx");
